var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMirror(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1800 3420c644.4 0 1170-727.2 1170-1620s-525.6-1620-1170-1620-1170 727.2-1170 1620 525.6 1620 1170 1620zm0-3060c547.2 0 990 644.4 990 1440s-442.8 1440-990 1440-990-644.4-990-1440 442.8-1440 990-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1800 3060c439.2 0 810-576 810-1260s-370.8-1260-810-1260-810 576-810 1260 370.8 1260 810 1260zm0-2340c331.2 0 630 514.8 630 1080s-298.8 1080-630 1080-630-514.8-630-1080 298.8-1080 630-1080z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1530 1890c21.602 0 46.801-7.1992 64.801-25.199l360-360c36-36 36-93.602 0-126-36-36-93.602-36-126 0l-360 360c-36 36-36 93.602 0 126 14.398 18 39.598 25.199 61.199 25.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1864.8 1915.2c-36-36-93.602-36-126 0l-270 270c-36 36-36 93.602 0 126 18 18 39.602 25.199 64.801 25.199 25.199 0 46.801-7.1992 64.801-25.199l270-270c28.797-32.398 28.797-90-3.6016-126z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1645.2 2584.8c18 18 39.602 25.199 64.801 25.199s46.801-7.1992 64.801-25.199l450-450c36-36 36-93.602 0-126-36-36-93.602-36-126 0l-453.6 446.4c-32.398 36-32.398 93.602 0 129.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirror);
export default __webpack_public_path__ + "static/media/mirror.ff5c3336b44ab54638db543afed572ad.svg";
export { ForwardRef as ReactComponent };